module.exports = __webpack_public_path__ + "img/inventory_planning_google_spreadsheet.cf509fef.svg";